import React, { useState }  from 'react';
import styles from 'components/show_drawing/redraw_form/_style.module.scss';
import Constants from 'components/show_drawing/Constants.jsx';
import MyEventListener from 'components/common/MyEventListener.jsx'
import renderOption from 'components/show_drawing/redraw_form/options/renderOption.jsx';

const OptionWithChildren = ( { id, drawing, option, unit, addToOptionsUserChanged, optionsUserChanged, setRedrawRequested, labelGroup = 'dimensions', inputName } ) => {
  const [childrenHidden, setChildrenHidden] = useState(true)

  const onRecoverySerValueHighlightMsg = (msg) => {
    if(msg.detail.id != id) { return; }
    const rule = msg.detail.rule;
    const apply_to_name = rule.recovery_apply_to.name;
    const isOurChild = option.children.some(child => child.name == apply_to_name);
    if(isOurChild) {
      setChildrenHidden( () => false )
    }
  }

  // Render the parent option itself as a leaf (by its input_type) without
  // losing option.children — the leaf components read option.children to
  // decide whether to render the Show/Hide children button.
  const renderSelf = () => renderOption({
    id,
    drawing,
    option,
    unit,
    optionsUserChanged,
    addToOptionsUserChanged,
    setRedrawRequested,
    labelGroup,
    inputName,
    renderAsLeaf: true
  })

  const renderChild = (child) => renderOption({
    id,
    drawing,
    option: child,
    unit,
    optionsUserChanged,
    addToOptionsUserChanged,
    setRedrawRequested,
    labelGroup
    // inputName intentionally not propagated: children carry their own names.
    // renderOption throws when inputName is set alongside children anyway.
  })

  const childOptionVisibleChangeMsg = (msg) => {
    if(msg.detail.id == id && msg.detail.name == option.name) {
      setChildrenHidden( () => !msg.detail.visible )
    }
  }

  // useEffect
  MyEventListener([
    {
      key: Constants.child_options_visible_change,
      callback: childOptionVisibleChangeMsg
    },{
      key: Constants.drawing_recovery_set_value_highlight_required,
      callback: onRecoverySerValueHighlightMsg,
    }
  ])
  // useEffect
  return (
    <div>
      {renderSelf()}
      {!childrenHidden && <div className={styles.child_option}> {option.children.map(renderChild)} </div> }
    </div>
  )
}

export default OptionWithChildren;
